// src/services/following.ts
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  setDoc,
  updateDoc,
  increment,
  getDoc,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

function followingRef(uid: string, targetUid: string) {
  return doc(db as any, 'users', uid, 'following', targetUid);
}

function userRef(uid: string) {
  return doc(db as any, 'users', uid);
}

export async function followUser(uid: string, targetUid: string) {
  if (!uid || !targetUid || uid === targetUid) return;

  const ref = followingRef(uid, targetUid);
  const existing = await getDoc(ref);
  if (existing.exists()) return;

  await setDoc(
    ref,
    {
      targetUid,
      createdAt: Date.now(),
    },
    { merge: true },
  );

  await updateDoc(userRef(uid), {
    followingCount: increment(1),
  }).catch(() => {});
}

export async function unfollowUser(uid: string, targetUid: string) {
  if (!uid || !targetUid || uid === targetUid) return;

  const ref = followingRef(uid, targetUid);
  const existing = await getDoc(ref);
  if (!existing.exists()) return;

  await deleteDoc(ref);

  await updateDoc(userRef(uid), {
    followingCount: increment(-1),
  }).catch(() => {});
}

export function subscribeToFollowing(
  uid: string,
  onChange: (ids: string[]) => void,
  onError?: (err: unknown) => void,
) {
  const ref = collection(db, 'users', uid, 'following');

  return onSnapshot(
    ref,
    (snap) => {
      const ids = snap.docs.map((d) => d.id);
      onChange(ids);
    },
    (err) => {
      if (onError) onError(err);
      else console.error('[following] subscribeToFollowing error', err);
    },
  );
}
